var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',[_c('a-col',{attrs:{"span":16}},[_c('refresh',{attrs:{"showSelect":"","tooltips":"","loading":_vm.loading},on:{"refresh":_vm.handleRefresh}}),_c('a-button',{staticStyle:{"margin-left":"8px"},on:{"click":_vm.createChart}},[_vm._v(" "+_vm._s(_vm.$t('monitor.dashboard.dialog.project.create'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }